import { Badge } from "@/components/ui/badge";

import {
  jobDifficultyToBgClasses,
  jobDifficultyToDotColor,
  jobDifficultyToLabel,
} from "@/lib/constants";
import { cn } from "@/lib/utils";
import { JobDifficulty } from "@/types";

export const TableJobDifficultyBadge = ({
  className,
  difficulty,
}: {
  className?: string;
  difficulty: JobDifficulty;
}) => {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "gap-2",
        jobDifficultyToBgClasses[difficulty],
        className,
      )}
    >
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          jobDifficultyToDotColor[difficulty],
        )}
      />
      {jobDifficultyToLabel[difficulty]}
    </Badge>
  );
};
